// CardDisplay.js
import "./css/mycss.css";
import { Cards } from "./Cards.js";
import img1 from "./images/pv_chakra.png";
import img2 from "./images/a_chakra.png";
import img3 from "./images/mv_chakra.png";
import img4 from "./images/Veer_chakra.png";
import img5 from "./images/k_chakra.png";
import img6 from "./images/S_Chakra.png";

// ✅ Export data so search can use these too
export const gallantryAwardsData = [
  {
    category: "Gallantry",
    htext: "Param Vir Chakra",
    ptext: "Highest wartime gallantry award.",
    img1: img1,
    ialt: "Param Vir Chakra",
    modalContent: `
        <b>Established:</b>26 January 1950 (in effect from 15 August 1947)</br>
        <b>Type:</b> Highest wartime gallantry award<br/>
        <b>First Awarded:</b>1947 (retroactively) </br>
        <b>First Recipient: </b>Major Somnath Sharma </br>
        <b> Material:</b> Bronze</br>
        <b> Symbolism:</b>The Indian national emblem in the center, surrounded by four replicas of Vajra (weapon of Lord Indra) symbolizing indestructible courage. </br>
        <b> Awarded For:</b>Most conspicuous bravery or self-sacrifice in the face of the enemy </br>
        <br/><b><a href='https://en.wikipedia.org/wiki/Param_Vir_Chakra'>wiki link</a></b> 
    `
  },
  {
    category: "Gallantry",
    htext: "Ashoka Chakra",
    ptext: "Highest peacetime gallantry award.",
    img1: img2,
    ialt: "Ashoka Chakra",
    modalContent: `
  <b>Established:</b> 26 January 1950 (effective from 15 August 1947)<br/>
  <b>Type:</b> Highest peacetime gallantry award </br>
  <b>First Awarded:</b> 1947 (retroactively)</br>
  <b>First Recipient:</b>Flight Lieutenant Suhas Biswas</br>
  <b>Material:</b>Bronze</br>
  <b>Symbolism:</b>Ashoka Chakra with 24 spokes representing righteousness and bravery.</br>
  <b>Awarded For:</b>Most conspicuous bravery away from the battlefield (peacetime operations).</br>
  <br/><b><a href='https://en.wikipedia.org/wiki/Ashoka_Chakra'>wiki link</a></b>
`
  },
  {
    category: "Gallantry",
    htext: "Maha Vir Chakra",
    ptext: "Second-highest wartime gallantry recognition.",
    img1: img3,
    ialt: "Maha Vir Chakra",
    modalContent: `
  <b>Established:</b>26 January 1950<br/>
  <b>Type:</b>Second-highest wartime gallantry award</br>
  <b>First Recipient:</b>Lt. Col Dewan Ranjit Rai</br>
  <b>Material:</b>Silver</br>
  <b>Symbolism:</b>A five-pointed star with the State Emblem in the center.</br>
  <b>Awarded For:</b>Exceptional acts of bravery in the presence of the enemy.</br>
  <br/><b><a href='https://en.wikipedia.org/wiki/Maha_Vir_Chakra'>wiki link</a></b>
`
  },
  {
    category: "Gallantry",
    htext: "Vir Chakra",
    ptext: "Awarded for exceptional bravery in battle.",
    img1: img4,
    ialt: "Vir Chakra",
    modalContent: `
  <b>Established:</b> 1947 <br/>
  <b>Type:</b>Third-highest wartime gallantry award</br>
  <b>First Awarded:</b>1947–48</br>
  <b>First Recipient:</b>Somnath Sharma.</br>
  <b>Material:</b>Silver</br>
  <b>Symbolism:</b>A chakra with the national emblem in the center.</br>
  <b>Awarded For:</b>Acts of gallantry in the battlefield.</br>
  <br/><b><a href='https://en.wikipedia.org/wiki/Vir_Chakra'>wiki link</a></b>
`
  },
  {
    category: "Gallantry",
    htext: "Kirti Chakra",
    ptext: "Awarded for valor and courageous action.",
    img1: img5,
    ialt: "Kirti Chakra",
    modalContent: `
  <b>Established:</b>4 January 1952<br/>
  <b>Type:</b>Second-highest peacetime gallantry award</br>
  <b>First Awarded:</b>Early 1950s</br>
  <b>First Recipient:</b>Joginder Singh Gharaya</br>
  <b>Material:</b>Silver</br>
  <b>Symbolism:</b>State Emblem within a lotus wreath or similar motif, indicating distinguished courage and sacrifice away from active war.</br>
  <b>Awarded For:</b> Conspicuous gallantry or self-sacrifice not in the presence of the enemy, including counter-terrorism and internal security operations.</br>
  <br/><b><a href='https://en.wikipedia.org/wiki/Kirti_Chakra'>wiki link</a></b>
`
  },
  {
    category: "Gallantry",
    htext: "Shaurya Chakra",
    ptext: "Awarded for exceptional courage shown during peacetime operations.",
    img1: img6,
    ialt: "Shaurya Chakra",
    modalContent: `
    <b>Established:</b> 4 January 1952<br/>
    <b>Type:</b>Third-highest peacetime gallantry award</br>
    <b>First Awarded:</b>1950s</br>
    <b>First Recipient:</b>Kulbir Thapa</br>
    <b>Material:</b>Bronze</br>
    <b>Symbolism:</b>State Emblem and simple circular design emphasizing “shaurya” (bravery) in internal security, rescue, and other non-war operations.</br>
    <b>Awarded For:</b>Acts of gallantry in situations not involving direct combat with an enemy, often during counter-insurgency, anti-terror, or rescue missions.</br>
  <br/><b><a href='https://en.wikipedia.org/wiki/Shaurya_Chakra'>wiki link</a></b>
`
  }
];

export function CardDisplay() {
  return (
    <div className="divcss3">
      <div className="divcss4">
        {gallantryAwardsData.slice(0, 4).map((award) => (
          <Cards
            key={award.htext}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>

      <div className="divcss3">
        {gallantryAwardsData.slice(4).map((award) => (
          <Cards
            key={award.htext}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}

export default CardDisplay;
